import { Link } from 'react-router-dom';
import { ArrowRight, PhoneCall } from 'lucide-react';
import { Button } from './ui/button';
import { company } from '../mock';

export default function CTASection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="relative rounded-xl overflow-hidden bg-fx-navy p-10 lg:p-16">
          <div className="absolute inset-0 opacity-25">
            <img src="https://images.unsplash.com/photo-1603814744174-115311ad645e?w=1600&q=80" alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-fx-navy via-fx-navy/85 to-fx-navy/40" />
          </div>
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8 text-white">
              <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Ready when you are</p>
              <h3 className="font-display text-3xl lg:text-4xl font-bold mt-3">Get the equipment you need — with terms that work.</h3>
              <p className="mt-4 text-white/80 max-w-xl">Submit your application in minutes. A dedicated advisor will respond with custom terms the same business day.</p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
              <Button asChild className="bg-fx-gold hover:bg-[#b88e36] text-fx-navy font-semibold rounded-sm h-12">
                <Link to="/contact">Contact Us <ArrowRight className="w-4 h-4 ml-2" /></Link>
              </Button>
              <Button asChild variant="outline" className="border-white/30 bg-transparent text-white hover:bg-white hover:text-fx-navy rounded-sm h-12">
                <a href={`tel:${company.phone}`}><PhoneCall className="w-4 h-4 mr-2" /> {company.phone}</a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
